import { Flex } from '@lego/klik-ui';
import { KpiDetails } from '@/components/kpi';
import { useDocumentTitle } from '@/hooks/common';

export const KpiDetailsPage = () => {
  useDocumentTitle('KPIs');
  return (
    <Flex flexDirection="column">
      <KpiDetails />
    </Flex>
  );
};
